import React from 'react';
import "./footerlink.css";

const Footerlink = (props) => {
    return ( 
        <span>{props.link}</span>
     );
}
 
export default Footerlink;